<template>
  <nuxt-child />
</template>

<script>
export default {
  head() {
    return {
      title: '爆款预定'
    }
  }
}
</script>
